import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from 'semantic-ui-react';
import MoreVert from '@material-ui/icons/MoreVert';
import Server from '../../functions/server'
import $ from "jquery";
import Dialogbox from './dialogbox';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Loading from '../loading';
import Release from '../../functions/release';

class Ticket extends React.Component {

  state = {
    data: [],
    open: false
  }

  viewBranch() {
    let context = this;
    context.setState({ load: true, message: 'Getting Datas' })
    $.ajax({
      type: 'POST',
      url: Server() + 'dashboard/tickets.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, open: true, load: false })
        } catch (e) {
          alert('Error to Get Data!!!!');
          context.setState({ load: false });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let ticket;
    let data = this.props.data.map((x) => {
      ticket = x.ticket;
    });
    if (ticket == null) {
      ticket = 0;
    }
    let fontSize = 25;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Card style={{backgroundColor: '#abb119', cursor: 'pointer'}}>
              <div style={{display: 'flex', padding: '2%'}}>
                <div style={{fontSize: 17, color: 'white'}}><b>Ticket</b></div>
                <div style={{paddingLeft: '59%', color: 'white', fontSize: 17, display: 'none'}}><MoreVert style={{cursor: 'pointer'}} /></div>
              </div>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Link to={"/"+Release()+"/tickets"} id='price_menu'>
                    <CardContent>
                        <div style={{color: 'white'}}>Pending & Processing<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: 15}}>{ticket}</b><br/>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this)} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
              </Grid>
            </Card>
          </Grid.Column>
        </Grid>
        { this.state.open ?
          (
            <div>
              <Dialogbox col3="Ticket(s)" col2="Assigned To" type="stock" data={this.state.data} open={this.state.open} handleClose={ () => { this.setState({ open: false }) }} title='Purchase Report' />
            </div>
          ) :
          (
            <div></div>
          )
        }
      </div>
    );
  }
}

export default Ticket;
